import React from "react";
import { FileUploaded } from "../types/type";

import uploaded from "../assets/images/uploaded.png";
import { useTranslation } from "react-i18next";

type FileUploadedItemProps = {
  file: FileUploaded;
};

const FileUploadedItem: React.FC<FileUploadedItemProps> = ({ file }) => {
  const { t } = useTranslation();
    
  return (
    <div className="flex justify-between items-center bg-white rounded-xl p-4 shadow-sm">
      {/* Infos fichier */}
      <div className="flex flex-col">
        <h4 className="font-bold text-gray-800">{file.name}</h4>
        <p className="text-blue-500 flex gap-10">{t("key_upload_complete")}</p>
      </div>

      {/* Icône */}
      <div className="flex items-center gap-4">
        <button
          className="text-gray-300 cursor-pointer hover:text-green-500 transition"
        >
          <img src={uploaded} alt="Icon Upload Success" />
        </button>
      </div>
    </div>
  );
};

export default FileUploadedItem;
